__turbopack_context__.v({
  "benefit": "ReferralCodeDisplay-module__bc06rq__benefit",
  "body": "ReferralCodeDisplay-module__bc06rq__body",
  "cardWrapper": "ReferralCodeDisplay-module__bc06rq__cardWrapper",
  "codeContainer": "ReferralCodeDisplay-module__bc06rq__codeContainer",
  "codeInput": "ReferralCodeDisplay-module__bc06rq__codeInput",
  "errorContainer": "ReferralCodeDisplay-module__bc06rq__errorContainer",
  "errorText": "ReferralCodeDisplay-module__bc06rq__errorText",
  "heading": "ReferralCodeDisplay-module__bc06rq__heading",
  "loadingText": "ReferralCodeDisplay-module__bc06rq__loadingText",
  "srOnly": "ReferralCodeDisplay-module__bc06rq__srOnly",
});
